import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard, Mail, Landmark, Plug } from "lucide-react";
import { useLang } from "@/i18n";

export default function IntegrationsPanel() {
  const { t } = useLang();
  const { data } = useQuery({ queryKey: ["integrations-status"], queryFn: () => api.get("/integrations/status").then((r) => r.data) });
  if (!data) return null;
  const rows = [
    { key: "stripe", icon: CreditCard, title: "Stripe", on: data.stripe?.enabled, hint: data.stripe?.enabled ? `${t("intStripeOn")} · ${data.stripe.mode}` : t("intStripeOff") },
    { key: "mollie", icon: CreditCard, title: "Mollie", on: data.mollie?.enabled, hint: data.mollie?.enabled ? `Bancontact · iDEAL · ${t("card")} · ${data.mollie.mode}` : t("intMollieOff") },
    { key: "email", icon: Mail, title: t("intEmail"), on: data.email?.enabled, hint: data.email?.enabled ? `${data.email.provider === "microsoft365" ? "Microsoft 365" : data.email.provider} · ${data.email.sender || ""}${data.email.fallback ? ` · reserve: ${data.email.fallback}` : ""}` : t("intEmailOff") },
    { key: "bank", icon: Landmark, title: t("intBank"), on: data.bank?.enabled, hint: data.bank?.enabled ? "Ponto" : t("intBankOff") },
  ];
  return (
    <Card className="p-6 border-border" data-testid="integrations-panel">
      <div className="flex items-center gap-2 mb-4">
        <Plug className="h-5 w-5 text-primary" />
        <div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">{t("intKicker")}</div>
          <h3 className="font-display text-xl font-bold">{t("intTitle")}</h3>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {rows.map(({ key, icon: Icon, title, on, hint }) => (
          <div key={key} className="flex items-start gap-3 rounded-md border border-border bg-muted/30 p-3" data-testid={`integration-${key}`}>
            <div className={`h-9 w-9 rounded-md border flex items-center justify-center shrink-0 ${on ? "bg-emerald-500/15 border-emerald-500/30 text-emerald-600" : "bg-muted border-border text-muted-foreground"}`}><Icon className="h-4 w-4" /></div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="font-semibold text-sm">{title}</span>
                <Badge className={on ? "bg-emerald-500/15 text-emerald-700 border-emerald-500/30" : "bg-muted text-muted-foreground border-border"} data-testid={`integration-${key}-status`}>{on ? t("intActive") : t("intInactive")}</Badge>
              </div>
              <div className="text-xs text-muted-foreground mt-0.5">{hint}</div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
